var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgFaQsBlkRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 415.75 415.75",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,311.81 H 311.81 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 415.75)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.91 64.552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-50.371 0-91.352 40.981-91.352 91.352 0 50.373 40.981 91.354 91.352 91.354 50.373 0 91.351-40.981 91.351-91.354 0-50.371-40.978-91.352-91.351-91.352m0 197.52c-58.542 0-106.17-47.627-106.17-106.17 0-58.539 47.624-106.16 106.17-106.16 58.541 0 106.16 47.626 106.16 106.16 0 58.541-47.624 106.17-106.16 106.17"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.88 205.29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-20.47 0-34.798-12.595-34.798-30.386v-1.573c0-0.474 0.314-0.789 0.788-0.789h13.383c0.474 0 0.788 0.315 0.788 0.789v1.573c0 8.974 7.244 17.003 19.839 17.003 14.639 0 22.04-9.916 22.04-18.893 0-7.084-2.045-12.595-17.161-18.894-7.555-3.146-11.335-8.344-11.335-15.113v-11.745c0-0.818 0.664-1.482 1.481-1.482h11.996c0.818 0 1.482 0.664 1.482 1.482v10.486c0.313 2.204 0.785 2.989 2.832 4.092 14.012 7.086 25.507 13.068 25.507 31.174 0 17.794-14.171 32.276-36.842 32.276"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.81 114.01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-11.993c-0.821 0-1.482-0.664-1.482-1.481v-11.997c0-0.818 0.661-1.481 1.482-1.481h11.993c0.817 0 1.481 0.663 1.481 1.481v11.997c0 0.817-0.664 1.481-1.481 1.481"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaQsBlkRgb);
export default __webpack_public_path__ + "static/media/FAQs_BLK_RGB.145725c3f12dba4d45de28e47cbeb497.svg";
export { ForwardRef as ReactComponent };